define(['text!edge/quoteandbind/common/directives/templates/editable-coverages.html', 'underscore', '../models/Coverage'],
    (templateStr, _, Coverage)=> {
        let guid = 0;

        return [()=> {
            return {
                restrict: 'A',
                template: templateStr,
                scope: {
                    coverages: '=gwQnbEditableCoverages',
                    loading: '=',
                    onCovChange: '=',
                    allowSelectCoverage: '=',
                },
                controller: ['$scope', ($scope)=> {
                    $scope.uid = `covs${guid++}`;
                    $scope.showSelect = $scope.allowSelectCoverage;

                    $scope.getPosition = function () {
                        if ($(window).width() < 1024) {
                            return 'bottom-right';
                        }

                        return 'right-top';
                    };

                    function isLoading() {
                        return $scope.loading;
                    }

                    function onChange() {
                        if ($scope.onCovChange) {
                            $scope.onCovChange();
                        }
                    }

                    function setNewModel() {
                        $scope.model = $scope.coverages.map(_.partial(Coverage.create, _, isLoading, onChange));
                    }

                    setNewModel();
                    $scope.$watch('coverages', setNewModel);

                }],
            };
        }];
    }
);



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/common/directives/EditableCoverages.js